module.exports = __webpack_public_path__ + "resources/img/img_ai_easymaker_en.694a6d0f5174cd3f455d436a0c078eda.png";